/* Script all functions
------------------------------------------------------------------------------*/

// Function to create and append SVG to an element
const mainHeader = document.querySelector('.main-header');

export const appendSVGBtn = (element, iconId, width, height) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
    svg.setAttribute('fill', 'currentColor');

    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', iconId);

    svg.appendChild(use);
    element.appendChild(svg);
};

/* Header add class and slide up top bar */
export const headeraddClass = () => {
    if (!mainHeader) {
        return;
    }

    const handleScroll = () => {
        const currentScroll = window.scrollY;
        if (currentScroll) {
            mainHeader.classList.add('stuck');
        } else {
            mainHeader.classList.remove('stuck');
        }
    };

    // Bind scroll listener
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
};

/* Slide Up, Down and Toggle Fucntion Start */
export const slideUp = (element, duration = 500, callback = null) => {
    const style = window.getComputedStyle(element);
    const paddingTop = style.paddingTop;
    const paddingBottom = style.paddingBottom;
    const marginTop = style.marginTop;
    const marginBottom = style.marginBottom;

    element.style.height = element.offsetHeight + 'px';
    // element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
    element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
    element.offsetHeight;

    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    setTimeout(() => {
        element.style.display = 'none';

        // Reset all styles
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');

        // Optionally reset to original
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;

        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
};

export const slideDown = (element, duration = 500, callback = null) => {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;

    if (display === 'none') {
        display = 'block';
    }
    element.style.display = display;

    const height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;

    element.offsetHeight; // force reflow

    // element.style.transition = height ${duration}ms, padding ${duration}ms, margin ${duration}ms;
    element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');

    setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');

        if (typeof callback === 'function') {
            callback();
        }
    }, duration);
};

export const slideToggle = (element, duration = 500) => {
    if (window.getComputedStyle(element).display === 'none') {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
};
/* Slide Up, Down and Toggle Fucntion End */


/* same-height element start */
export const sameHeight = (elemSelector, heightType) => {
    const elements = document.querySelectorAll(elemSelector);
    let maxHeight = 0;
    heightType = heightType === undefined ? 'min-height' : 'height';
    elements.forEach(el => {
        el.style[heightType] = 'auto';
    });
    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    elements.forEach(el => {
        el.style[heightType] = maxHeight + 'px';
    });
};
/* same-height element end */

/* Fade In function Start */
export const updateFocusedClass = (selector) => {
    selector.forEach(function(field) {
        const value = field.value;
        const fieldWrap = field.closest('.gfield');

        if (value && value !== '(___) ___-____') {
            fieldWrap.classList.add('focused');
        } else {
            fieldWrap.classList.remove('focused', 'focused_effect');
        }

        field.addEventListener('focus', function() {
            field.closest('.gfield').classList.add('focused', 'focused_effect');
        });

        field.addEventListener('blur', function() {
            const value = field.value;
            const fieldWrap = field.closest('.gfield');

            if (!value || value === '(___) ___-____') {
                fieldWrap.classList.remove('focused', 'focused_effect');
            } else {
                fieldWrap.classList.add('focused');
            }
            fieldWrap.classList.remove('focused_effect');
        });
    });
};
/* form focus end */

// Fade In function
export const fadeIn = (el, duration = 400) => {
    el.style.opacity = 0;
    el.style.display = 'block';
    const start = performance.now();

    function animate(time) {
        let progress = (time - start) / duration;
        if (progress > 1) {
            progress = 1;
        }
        el.style.opacity = progress;
        if (progress < 1) {
            requestAnimationFrame(animate);
        }
    }
    requestAnimationFrame(animate);
};
/* Fade In function End */
